import { Controller } from '@hotwired/stimulus'

// Карточка каталога. На десктопе описание раскрывается по наведению (CSS),
// на тач-устройствах первый тап открывает оверлей, а не уводит в игру:
// иначе описание игры увидеть невозможно.
export default class extends Controller {
  static targets = ['overlay']
  static values = { url: String }

  connect() {
    this.touch = window.matchMedia('(pointer: coarse)').matches
  }

  click(event) {
    if (!this.urlValue) return
    if (event.target.closest('a')) return

    if (!this.touch) {
      window.location.href = this.urlValue
      return
    }

    const wasOpen = this.overlayTarget.dataset.open === 'true'
    document.querySelectorAll('[data-card-target="overlay"]').forEach((el) => { el.dataset.open = 'false' })
    this.overlayTarget.dataset.open = wasOpen ? 'false' : 'true'
  }
}
